import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { FiscalMonthPayload } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const saveFiscalMonth = async (payload: FiscalMonthPayload): Promise<any> => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const result: any = await performPostRequest('/rest/jpo/1.0/fiscalYear', {
		method: 'POST',
		body: JSON.stringify(payload),
	});
	return result;
};
